import React from 'react';
import styles from './styles.module.css';
import LsqStatusBadge from '../../../../../components/LsqStatusBadge';

const TeamsViewMenuCard = ({ menu, cardClickHandler }) => {
  return (
    <div
      className={styles['menu-card-container']}
      data-testid="teams-view-menu-card"
      onClick={cardClickHandler}>
      <LsqStatusBadge variant="dot" status={menu?.status} />
      <span title={menu?.name}>{menu?.name}</span>
    </div>
  );
};

export default TeamsViewMenuCard;
